import { useState, useEffect, useCallback } from 'react';
import { invoices as invoicesApi } from 'utilities/api';
import catchCancel from 'helpers/catchCancel';

const useInventoryInvoiceData = prodId => {
  const [invoices, setInvoices] = useState([]);
  const [invsLoading, setInvsLoading] = useState(true);
  const [invsError, setInvsError] = useState(null);

  const getAllInvoices = useCallback(productId => {
    // `size` has to go through the params argument. Passing it in the id slot
    // built `/v1/invoices/?size=10000`, and the trailing slash is unroutable on
    // the Java backend (404), which left this table silently empty.
    const { promise } = invoicesApi.fetch(null, { size: 10000 });
    promise
      .then(data => {
        const apiInvoices = data.data.results.filter(inv => {
          const invoiceProducts = inv.invoiceProducts ?? [];
          const hasProduct =
            invoiceProducts.filter(
              prod => prod.productId === productId || prod.id === productId
            ).length > 0;
          return hasProduct ? inv : null;
        });
        setInvoices(apiInvoices);
        setInvsLoading(false);
      })
      .catch(err => {
        setInvsError(err);
        setInvsLoading(false);
      })
      .catch(catchCancel);
  }, []);
  useEffect(() => {
    setInvsLoading(true);
    getAllInvoices(prodId);
  }, [prodId, getAllInvoices]);

  return { invoices, invsLoading, invsError };
};

export default useInventoryInvoiceData;
